import { Injectable } from '@angular/core';
import { PaymentFormData, Agent, Address, BillingInformation } from '../models';

@Injectable()
export class PaymentService {
    private basePaymentUrl: string;

    public setBaseUrl(baseUrl: string): void {
        this.basePaymentUrl = baseUrl;
    }

    public get baseUrl(): string {
        return this.basePaymentUrl;
    }

    public getIframeUrl(paymentFormData: PaymentFormData): string {
        let queryParams: string = '?';

        // simplify only accepts a single line address
        let address: BillingInformation = this.mapBillingInformation(paymentFormData);

        // if there's no state provided, they might make it through payment without providing a state,
        // which breaks purchase and is bad in general, so force them to enter a billing address
        if (address.stateOrProvince) {
            queryParams += 'address=' + encodeURIComponent(this.valOrEmptyString(address.address1));
            queryParams += '&state=' + encodeURIComponent(this.valOrEmptyString(address.stateOrProvince));
        } else {
            queryParams += 'address=';
        }

        queryParams += '&city=' + encodeURIComponent(this.valOrEmptyString(address.city));
        queryParams += '&zip=' + encodeURIComponent(this.valOrEmptyString(address.postalCode));

        // pass the logged in agent's email address to the payment form when no email has been provided
        // by the primary traveler. This is a work around for a bug with the simplify form
        let paramEmail: string = address.email;

        if (!paramEmail && paymentFormData.agent) {
            paramEmail = paymentFormData.agent.emailAddress;
        }

        // fall back to agent@bhtp.com if the agent's email address is null
        queryParams += '&email=' + encodeURIComponent(this.valOrEmptyString(paramEmail ? paramEmail : 'agent@bhtp.com'));

        queryParams += '&name=' + encodeURIComponent(this.valOrEmptyString(address.name));

        queryParams += '&buttonText=Complete%20Purchase';

        let url: string = this.basePaymentUrl + queryParams;
        return url;
    }

    private mapBillingInformation(paymentFormData: PaymentFormData): BillingInformation {
        let address: BillingInformation = new BillingInformation();

        // Use the address if it exists
        if (paymentFormData.address) {
            address.address1 = this.buildAddressStreet(paymentFormData.address.address1, paymentFormData.address.address2);
            address.city = paymentFormData.address.city;
            address.stateOrProvince = paymentFormData.address.stateOrProvince;
            address.postalCode = paymentFormData.address.postalCode;
            address.email = paymentFormData.emailAddress;
            if (paymentFormData.primaryTravelerName) {
                address.name = this.valOrEmptyString(paymentFormData.primaryTravelerName);
            } else {
                address.name = this.valOrEmptyString(paymentFormData.firstName) + ' ' + this.valOrEmptyString(paymentFormData.lastName);
            }
        } else {
            // Use billing address if there is no primary address
            address.address1 = this.buildAddressStreet(paymentFormData.billing.address1, paymentFormData.billing.address2);
            address.city = paymentFormData.billing.city;
            address.stateOrProvince = paymentFormData.billing.stateOrProvince;
            address.postalCode = paymentFormData.billing.postalCode;
            address.email = paymentFormData.billing.email;
            address.name = paymentFormData.billing.name;
        }

        if (paymentFormData.billing) {
            address.customerId = paymentFormData.billing.customerId;
        }

        return address;
    }

    private buildAddressStreet(address1: string, address2: string): string {
        let streetAddress: string = address1;

        if (streetAddress && address2) {
            streetAddress += ' ' + address2;
        }

        return streetAddress;
    }

    private valOrEmptyString(val): string {
        if (val == null || val === undefined) {
            return '';
        }
        return val;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/services/payment.service.ts